<div class="loader-wrapper">
    <div class="loader-content loading">
        <div class="loader-pane-processing my-4">
            <h1 class="mb-3">Exiting portal</h1>
            <div class="processing">
                <div class="rectangle_1"></div>
                <div class="rectangle_2"></div>
                <div class="rectangle_3"></div>
                <div class="rectangle_4"></div>
                <div class="rectangle_5"></div>
                <div class="rectangle_6"></div>
                <div class="rectangle_7"></div>
                <div class="rectangle_8"></div>
                <div class="rectangle_9"></div>
                <div class="rectangle_10"></div>
                <div class="rectangle_11"></div>
                <div class="rectangle_12"></div>
                <div class="rectangle_13"></div>
                <div class="rectangle_14"></div>
                <div class="rectangle_15"></div>
                <div class="rectangle_16"></div>
                <div class="rectangle_17"></div>
                <div class="rectangle_18"></div>
                <div class="rectangle_19"></div>
                <div class="rectangle_20"></div>
            </div>
            <p class="my-2">Please wait a few minutes</p>
        </div>
    </div>
</div>
